/*
 *@Description: 基础工具库
 *@Author: zhengff
 *@Date: 2019-04-21 22:57:22
 */
var toString = Object.prototype.toString

const BASE = {
  isEmpty: function(value) {
    return this.isUndefined(value) || value === '' || value === null
  },
  isUndefined: function(value) {
    return typeof value === 'undefined'
  },
  isDefined: function(value) {
    return typeof value !== 'undefined'
  },
  isObject: function(value) {
    return value !== null && typeof value === 'object'
  },
  isString: function(value) {
    return typeof value === 'string'
  },
  isNumber: function(val) {
    var patrn = /^(-)?\d+(\.\d+)?$/
    if (patrn.exec(val) == null || val == '') {
      return false
    } else {
      return true
    }
  },
  isDate: function(value) {
    return toString.call(value) === '[object Date]'
  },
  isArray: function(value) {
    return toString.call(value) == '[object Array]'
  },
  isFunction: function(value) {
    return typeof value === 'function'
  },
  isBoolean: function(value) {
    return value === true || value === false
  },
  isRegExp: function(value) {
    return value instanceof RegExp
  },
  clone: function(obj) {
    if (
      typeof obj != 'object' ||
      BASE.isDate(obj) ||
      obj === null ||
      obj === void 0
    )
      return obj
    var re
    if (obj.constructor == Array) {
      re = []
    } else {
      re = {}
    }
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        re[i] = BASE.clone(obj[i])
      }
    }
    return re
  },
  //获取命名空间下属性
  getAttribute: function(parent, namespace, defaultResult) {
    if (parent && namespace) {
      var ns = namespace.split('.')
      var obj = parent
      for (var i = 0, l = ns.length; i < l; i++) {
        obj = obj[ns[i]]
        if (obj == null || obj == void 0) {
          return defaultResult
        }
      }
      return obj
    }
    return defaultResult
  },
  //设置命名空间下的属性
  setAttribute: function(parent, namespace, value) {
    var lio,
      obj = parent
    if ((lio = namespace.lastIndexOf('.'))) {
      var ns = namespace.split('.'),
        obj = parent,
        attrName = namespace.substring(lio + 1)
      for (var i = 0, l = ns.length - 1; i < l; i++) {
        if (obj[ns[i]] == null || obj[ns[i]] === void 0) {
          obj[ns[i]] = {}
        }
        obj = obj[ns[i]]
      }
      obj[attrName] = value
    } else {
      obj[namespace] = value
    }
  },
  getCookie: function(name) {
    var arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if ((arr = document.cookie.match(reg))) return unescape(arr[2])
    else return null
  },
  /**
   * 获取URL参数
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  getQueryString: function(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  wait: function(promiseFactory, cacheHolder, cacheKey) {
    var lock = false,
      resolveStack = [],
      cacheKey = cacheKey || 'cache'
    cacheHolder = cacheHolder || {}
    return function(force) {
      var self = this,
        args = [].slice.call(arguments)
      return new Promise((resolve, reject) => {
        if (!force && cacheHolder[cacheKey]) {
          resolve(cacheHolder[cacheKey])
        } else {
          resolveStack.push({
            resolve: resolve,
            reject: reject
          })
          if (!lock) {
            lock = true
            promiseFactory
              .apply(self, args)
              .then(res => {
                cacheHolder[cacheKey] = res
                lock = false
                while (resolveStack.length) {
                  resolveStack.shift().resolve(res)
                }
              })
              .catch(err => {
                lock = false
                while (resolveStack.length) {
                  resolveStack.shift().reject(err)
                }
              })
          }
        }
      })
    }
  },
  debounce: function(fn, delay) {
    let timer = null
    return function() {
      let context = this
      let args = arguments
      clearTimeout(timer)
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
  },
  debounce: function debouce(func, delay, immediate) {
    var timer = null
    return function() {
      var context = this
      var args = arguments
      if (timer) clearTimeout(timer)
      if (immediate) {
        var doNow = !timer
        timer = setTimeout(function() {
          timer = null
        }, delay)
        if (doNow) {
          func.apply(context, args)
        }
      } else {
        timer = setTimeout(function() {
          func.apply(context, args)
        }, delay)
      }
    }
  },
  throttle: function(func, delay) {
    var timer = null
    var startTime = Date.now()

    return function() {
      var curTime = Date.now()
      var remaining = delay - (curTime - startTime)
      var context = this
      var args = arguments

      clearTimeout(timer)
      if (remaining <= 0) {
        func.apply(context, args)
        startTime = Date.now()
      } else {
        timer = setTimeout(func, remaining)
      }
    }
  },
  Numbers: {
    fixed: function(value, digits) {
      digits = digits || 0
      var v, res
      try {
        v = +value
        if (!isNaN(v)) {
          if (digits == 0) {
            res = Math.round(v)
          } else {
            res = v.toFixed(digits)
          }
        } else {
          if (digits == 0) {
            res = 0
          } else {
            res = (0).toFixed(digits)
          }
        }
      } catch (e) {
        if (digits == 0) {
          res = 0
        } else {
          res = (0).toFixed(digits)
        }
      }
      return res
    }
  },
  /**
   * 字符串操作工具
   */
  Strings: {
    toCamelCase(str) {
      return BASE.isString(str)
        ? str.replace(new RegExp('\\-(\\w)', 'g'), function(all, letter) {
            return letter.toUpperCase()
          })
        : str
    },
    toHyphenate(str) {
      return BASE.isString(str)
        ? str.replace(new RegExp('([A-Z])', 'g'), '-$1').toLowerCase()
        : str
    },
    removeAsSpliter: function(str, obj, spliter) {
      var spliter = spliter === void 0 ? ',' : spliter
      var list = str.split(spliter)
      list.splice(list.indexOf(obj), 1)
      return list.join(spliter)
    },
    serialize: function(data) {
      return Object.keys(data)
        .map(function(keyName) {
          return (
            encodeURIComponent(keyName) +
            '=' +
            encodeURIComponent(data[keyName])
          )
        })
        .join('&')
    }
  },
  //数组操作工具
  Arrays: {
    /**
     * 添加全部
     * @param {[type]} arr1 [description]
     * @param {[type]} arr2 [description]
     */
    addAll: function(arr1, arr2) {
      if (arr2 && arr2.length) {
        [].push.apply(arr1, arr2)
      }
      return arr1
    },
    /**
     * 去重
     * @param  {[type]} arr [description]
     * @param  {[type]} key [description]
     * @return {[type]}     [description]
     */
    uniq: function(arr, key) {
      if (arr && arr.length) {
        var hash = {},
          res = [],
          temp,
          id
        for (var i = 0, l = arr.length; i < l; i++) {
          temp = arr[i]
          id = key ? utils.getAttribute(temp, key) : temp
          if (!hash[id]) {
            hash[id] = true
            res.push(temp)
          }
        }
        return res
      } else {
        return arr
      }
    },
    remove: function(arr, obj) {
      if (arr && arr.length && obj) {
        for (var i = 0, l = arr.length; i < l; i++) {
          if (arr[i] == obj) {
            arr.splice(i, 1)
            break
          }
        }
      }
    },
    filter: function(items, cb) {
      if (!items || items.length == 0) {
        return null
      }
      if (typeof cb != 'function') {
        throw new Error('filter arguments[1] is not a function')
      }
      var res = []
      for (var i = 0, l = items.length; i < l; i++) {
        if (cb(items[i])) {
          res.push(items[i])
        }
      }
      return res
    },
    filterOne: function(items, cb) {
      if (!items || items.length == 0) {
        return null
      }
      if (typeof cb != 'function') {
        throw new Error('filter arguments[1] is not a function')
      }
      for (var i = 0, l = items.length; i < l; i++) {
        if (cb(items[i])) {
          return items[i]
        }
      }
    },
    forEach: function(items, cb) {
      if (!items || items.length == 0) {
        return null
      }
      if (typeof cb != 'function') {
        throw new Error('filter arguments[1] is not a function')
      }
      for (var i = 0, l = items.length; i < l; i++) {
        cb(items[i], i)
      }
      return items
    },
    some: function(items, cb) {
      if (!items || items.length == 0) {
        return null
      }
      if (typeof cb != 'function') {
        throw new Error('filter arguments[1] is not a function')
      }
      for (var i = 0, l = items.length; i < l; i++) {
        if (cb(items[i], i)) {
          return true
        }
      }
      return false
    },
    map: function(arr, cb) {
      var res = []
      if (arr && arr.length) {
        for (var i = 0, l = arr.length; i < l; i++) {
          res.push(cb(arr[i]))
        }
      }
      return res
    },
    merge: function(mergeTo, mergeFrom, compare) {
      var item,
        jitem,
        isNew = true
      compare =
        compare ||
        function(obj1, obj2) {
          return obj1 === obj2
        }
      if (mergeTo && mergeFrom && compare) {
        for (var i = 0, l = mergeFrom.length; i < l; i++) {
          item = mergeFrom[i]
          isNew = true
          for (var j = 0, jl = mergeTo.length; j < jl; j++) {
            jitem = mergeTo[j]
            if (compare(item, jitem)) {
              isNew = false
              mergeTo.splice(j, 1, item)
            }
          }
          isNew && mergeTo.push(item)
        }
      }
      return mergeTo
    },
    findIndex(items, find) {
      if (!items || items.length == 0) {
        return -1
      }
      if (typeof find != 'function') {
        throw new Error('filter arguments[1] is not a function')
      }
      for (var i = 0, l = items.length; i < l; i++) {
        if (find(items[i])) {
          return i
        }
      }
      return -1
    }
  },
  Objects: {
    each: function(obj, cb) {
      if (obj) {
        var key
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            cb(obj[key], key, obj)
          }
        }
      }
    }
  }
}

/***********************高级工具库*****************************/
/**
 * 判断是否为空
 */
const validatenull = val => {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length == 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (
      val == 'null' ||
      val == null ||
      val == 'undefined' ||
      val == undefined ||
      val == ''
    )
      return true
    return false
  }
  return false
}

// 表单序列化
const serialize = data => {
  let list = []
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`)
  })
  return list.join('&')
}

const getObjType = obj => {
  var toString = Object.prototype.toString
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}
/**
 * 对象深拷贝
 */
const deepClone = data => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
/**
 * 判断路由是否相等
 */
const diff = (obj1, obj2) => {
  delete obj1.close
  var o1 = obj1 instanceof Object
  var o2 = obj2 instanceof Object
  if (!o1 || !o2) {
    /*  判断不是对象  */
    return obj1 === obj2
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }

  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object
    var t2 = obj2[attr] instanceof Object
    if (t1 && t2) {
      return diff(obj1[attr], obj2[attr])
    } else if (obj1[attr] !== obj2[attr]) {
      return false
    }
  }
  return true
}
/**
 * 设置灰度模式
 */
const toggleGrayMode = status => {
  if (status) {
    document.body.className = document.body.className + ' grayMode'
  } else {
    document.body.className = document.body.className.replace(' grayMode', '')
  }
}
/**
 * 设置主题
 */
const setTheme = name => {
  document.body.className = name
}

/**
 *加密处理
 */
const encryption = params => {
  let { data, type, param, key } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      })
      result[ele] = encrypted.toString()
    })
  }
  return result
}

/**
 * 浏览器判断是否全屏
 */
const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen()
  } else {
    reqFullScreen()
  }
}
/**
 * esc监听全屏
 */
const listenfullscreen = callback => {
  function listen() {
    callback()
  }
  document.addEventListener('fullscreenchange', function() {
    listen()
  })
  document.addEventListener('mozfullscreenchange', function() {
    listen()
  })
  document.addEventListener('webkitfullscreenchange', function() {
    listen()
  })
  document.addEventListener('msfullscreenchange', function() {
    listen()
  })
}
/**
 * 浏览器判断是否全屏
 */
const fullscreenEnable = () => {
  return (
    document.isFullScreen ||
    document.mozIsFullScreen ||
    document.webkitIsFullScreen
  )
}

/**
 * 浏览器全屏
 */
const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen()
  }
}
/**
 * 浏览器退出全屏
 */
const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen()
  }
}
/**
 * 递归寻找子类的父类
 */

const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length != 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id == id) {
          return menu[i]
        } else {
          if (menu[i].children[j].children.length != 0) {
            return findParent(menu[i].children[j].children, id)
          }
        }
      }
    }
  }
}

/**
 * 动态插入css
 */

const loadStyle = url => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}
/**
 * 判断路由是否相等
 */
const isObjectValueEqual = (a, b) => {
  let result = true
  Object.keys(a).forEach(ele => {
    const type = typeof a[ele]
    if (type === 'string' && a[ele] !== b[ele]) result = false
    else if (
      type === 'object' &&
      JSON.stringify(a[ele]) !== JSON.stringify(b[ele])
    )
      result = false
  })
  return result
}
/**
 * 根据字典的value显示label
 */
const findByvalue = (dic, value) => {
  let result = ''
  if (validatenull(dic)) return value
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    let index = 0
    index = findArray(dic, value)
    if (index != -1) {
      result = dic[index].label
    } else {
      result = value
    }
  } else if (value instanceof Array) {
    result = []
    let index = 0
    value.forEach(ele => {
      index = findArray(dic, ele)
      if (index != -1) {
        result.push(dic[index].label)
      } else {
        result.push(value)
      }
    })
    result = result.toString()
  }
  return result
}
/**
 * 根据字典的value查找对应的index
 */
const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value == value) {
      return i
    }
  }
  return -1
}
/**
 * 生成随机len位数字
 */
const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}

// 根据文件名后缀区分 文件类型
/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 * @param: 数据返回 10) 其他匹配项 - other
 */
const matchType = fileName => {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false
    return result
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }
  // 匹配txt
  var txtlist = ['txt']
  result = txtlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'txt'
    return result
  }
  // 匹配 excel
  var excelist = ['xls', 'xlsx']
  result = excelist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'excel'
    return result
  }
  // 匹配 word
  var wordlist = ['doc', 'docx']
  result = wordlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'word'
    return result
  }
  // 匹配 pdf
  var pdflist = ['pdf']
  result = pdflist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'pdf'
    return result
  }
  // 匹配 ppt
  var pptlist = ['ppt']
  result = pptlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'ppt'
    return result
  }
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv']
  result = videolist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv']
  result = radiolist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'radio'
    return result
  }
  // 其他 文件类型
  result = 'other'
  return result
}

const getfilesize = size => {
  if (!size) return ''

  var num = 1024.0 //byte

  if (size < num) return size + 'B'
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + 'K' //kb
  if (size < Math.pow(num, 3)) return (size / Math.pow(num, 2)).toFixed(2) + 'M' //M
  if (size < Math.pow(num, 4)) return (size / Math.pow(num, 3)).toFixed(2) + 'G' //G
  return (size / Math.pow(num, 4)).toFixed(2) + 'T' //T
}

const advance = {
  matchType: matchType,
  // 判断是否为空
  validatenull: validatenull,
  // 表单序列化
  serialize: serialize,
  // 获取数据类型
  getObjType: getObjType,
  // 对象深拷贝
  deepClone: deepClone,
  // 判断路由是否相等
  diff: diff,
  // 设置灰度模式
  toggleGrayMode: toggleGrayMode,
  // 设置主题
  setTheme: setTheme,
  // 加密处理
  encryption: encryption,
  // 浏览器判断是否全屏
  fullscreenToggel: fullscreenToggel,
  // esc监听全屏
  listenfullscreen: listenfullscreen,
  // 浏览器判断是否全屏
  fullscreenEnable: fullscreenEnable,
  // 浏览器全屏
  reqFullScreen: reqFullScreen,
  // 浏览器退出全屏
  exitFullScreen: exitFullScreen,
  // 递归寻找子类的父类
  findParent: findParent,
  // 动态插入css
  loadStyle: loadStyle,
  // 判断路由是否相等
  isObjectValueEqual: isObjectValueEqual,
  // 根据字典的value显示label
  findByvalue: findByvalue,
  // 根据字典的value查找对应的index
  findArray: findArray,
  // 生成随机len位数字
  randomLenNum: randomLenNum,
  // 获取文件的大小
  getfilesize: getfilesize
}

// 基础工具库进行合并
Object.assign(BASE, advance)

export default BASE
